import { Notification } from "element-ui";
export function showAlarm({ type, message }) {
  console.log(type, message);
  switch (type) {
    case "success":
      return Notification.success({
        title: "Success",
        dangerouslyUseHTMLString: true,
        message: message ? message : "Action completed successfully"
      });

    case "warning":
      return Notification.error({
        title: "Error",
        dangerouslyUseHTMLString: true,
        message: message
      });
    default:
      return Notification.warning({
        title: "Unknown",
        dangerouslyUseHTMLString: true,
        message: message ? message : "unknown, please verify"
      });
  }
}



// WEBPACK FOOTER //
// ./src/utils/notification.js